<template>
  <v-app id="app">
    <app-header
      :class="{
        'is-hidden':
          $route.path === '/' ||
          $route.path === '/question'
      }"
    ></app-header>
    <router-view></router-view>
  </v-app>
</template>

<script>
import appHeader from "./components/Header";

import { AmplifyEventBus } from "aws-amplify-vue";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  computed: mapGetters(["getLoginState", "getLoginUserId"]),
  name: "app",
  data() {
    return {
      signedIn: false
    };
  },

  methods: {
    ...mapMutations([
      "setValueToLoginState",
      "setValueToLoginUserId",
      "setValueToAccessToken"
    ])
  },

  created() {
    AmplifyEventBus.$on("authState", info => {
      if (info === "signedIn") {
        this.$store.commit("setValueToLoginState", true);
        this.$router.push("/mytop");
      }

      if (info === "signedOut") {
        this.$router.push("/auth");
        this.$store.commit("setValueToLoginState", false);
        this.$router.push("/");
      }



    });
  },
  components: {
    appHeader
  }
};
</script>

<style>
html, .v-application{
  font-family: "Roboto", "Noto Sans JP", sans-serif !important;
  background-color: #5592c6;
  -ms-overflow-style: none;
  overscroll-behavior: none;
}


.nav {
  display: flex;
}

.nav p:hover {
  opacity: 0.7;
}

.sign-out {
  width: 160px;
  margin: 0 auto;
}

.nav-btn {
  margin-left: 20px;
  background-color: #8c1515;
}

.v-app-bar {
  background-color: #8c1515;
}

.is-hidden {
  display: none;
}

@-ms-viewport {
    width: auto;
    initial-scale: 1;
}
</style>
